import { db } from "@/firebase/firebaseConfig";
import {
  collection,
  getDoc,
  getDocs,
  doc,
  setDoc,
  deleteDoc,
  query,
  where,
} from "firebase/firestore";

/**
 * ✅ Fetch All Users from Firestore
 */
export const getUsers = async (token) => {
  try {
    if (!token) throw new Error("Missing authentication token.");

    const usersRef = collection(db, "users");

    // ✅ Use Firebase Query to Filter Users by Role
    const q = query(usersRef, where("role", "!=", "")); // Get all admins "user"
    const querySnapshot = await getDocs(q);

    return querySnapshot.docs.map((doc) => ({
      id: doc.id, // Email as document ID
      ...doc.data(),
    }));
  } catch (error) {
    console.error("❌ Error fetching users:", error);
    throw error;
  }
};

/**
 * ✅ Add New User to Firestore & Set Role in Firebase Authentication
 */
export const addUser = async (user, adminEmail) => {
  try {
    const userRef = doc(db, "users", user.email);
    user.password = "123456abcdef";
    // ✅ Check if the user already exists
    const existingUser = await getDoc(userRef);
    if (existingUser.exists()) {
      throw new Error("❌ User already exists!");
    }

    // ✅ Save to Firestore
    await setDoc(userRef, {
      email: user.email,
      password: user.password,
      role: user.role,
      shopId: user.shopId || null,
      createdBy: adminEmail,
      createdAt: new Date(),
    });

    // ✅ Set Custom Claims in Firebase Authentication (Cloud Function)
    await fetch("https://setuserrole-u32waniu4a-df.a.run.app", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: user.email,
        role: user.role,
        shopId: user.shopId || null,
        password: user.password,
      }),
    });

    console.log("✅ User added successfully:", user);
  } catch (error) {
    console.error("❌ Error adding user:", error);
    throw error;
  }
};

/**
 * ✅ Update Existing User Role & Shop
 */
export const updateUser = async (user) => {
  try {
    const userRef = doc(db, "users", user.email);

    // ✅ Ensure User Exists
    const existingUser = await getDoc(userRef);
    if (!existingUser.exists()) {
      throw new Error("❌ User not found!");
    }

    // ✅ Update Firestore User Data
    await setDoc(userRef, user, { merge: true });

    // ✅ Update Firebase Authentication Custom Claims
    await fetch("https://setuserrole-u32waniu4a-df.a.run.app", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: user.email,
        role: user.role,
        shopId: user.shopId || null,
      }),
    });

    console.log("✅ User updated successfully:", user);
  } catch (error) {
    console.error("❌ Error updating user:", error);
    throw error;
  }
};

/**
 * ✅ Delete User from Firestore
 */
export const deleteUser = async (email) => {
  try {
    const userRef = doc(db, "users", email);
    await deleteDoc(userRef);
    console.log("✅ User deleted successfully:", email);
  } catch (error) {
    console.error("❌ Error deleting user:", error);
    throw error;
  }
};
